import { connect } from 'react-redux'
import SridSelector from './SridSelector.js';
import { changeSrid } from '../../actionCreators';

const mapStateToProps = (state, ownProps) => ({
	value: state.srid
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	onChange: (event) => dispatch(changeSrid(event.target.value))
});

export default connect(mapStateToProps, mapDispatchToProps)(SridSelector);


// WEBPACK FOOTER //
// ./src/components/Filter/SridSelectorContainer.js